import type React from 'react';
import { styled } from 'styled-components';

type DateFieldsOwnProps = {
  dataTestId?: string;
  $fullWidth?: boolean;
  $clearable?: boolean;
};

export type DateFieldsProps = React.HTMLAttributes<HTMLDivElement> & DateFieldsOwnProps;

const WIDTH = 220;
const CLEAR_ICON_PADDING = 26;

const getWidth = ({ $fullWidth, $clearable }: DateFieldsOwnProps): string => {
  if ($fullWidth) {
    return '100%';
  }

  const width = $clearable ? WIDTH + CLEAR_ICON_PADDING * 2 : WIDTH;

  return `${width}px`;
};

export const DateFields = styled.div<DateFieldsOwnProps>`
  display: flex;
  width: ${getWidth};
  > * {
    min-width: calc(50% - 5px);
    max-width: calc(50% - 5px);
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;
